import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'

import { OfflineConsultation } from '@/core/offline'

import { OfflineConsultationsCardView } from './OfflineConsultationsCardView'

type OfflineConsultationsMobileProps = {
  consultations: OfflineConsultation[]
  loading?: boolean
  onOpen?: (consultation: OfflineConsultation) => void
}

export function OfflineConsultationsMobile({ consultations, loading, onOpen }: OfflineConsultationsMobileProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleOpen = (consultation: OfflineConsultation) => {
    if (onOpen) {
      onOpen(consultation)
    } else {
      // Navigate to consultation details page (works for all statuses)
      navigate(`/offline/consultations/${consultation._offlineId || consultation._id}`)
    }
  }

  if (loading) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography>{t('Loading consultations...')}</Typography>
      </Box>
    )
  }

  if (!consultations.length) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography>{t('No offline consultations found')}</Typography>
      </Box>
    )
  }

  return <OfflineConsultationsCardView consultations={consultations} onOpen={handleOpen} />
}
